import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import ExportExcel from "../../../../Components/StickyToolbar/ExportExcel";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { ListarEmpreendimentosController, ListarProdutosPorEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { AcompanhamentoVistoriaExportarExcelController } from "../../../../Controllers/VistoriaEntregaChaves/AcompanhamentosVistoria/AcompanhamentosVistoriaController";
import { IAcompanhamentoVistoriaFiltro } from "../../../../Interfaces/VistoriaEntregaChaves/AcompanhamentosVistoria/AcompanhamentosVistoriaInterfaces";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import Select from "react-select";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";

interface IFiltroAcompanhamentosVistoriaProps {
    handleSubmit: (filter: IAcompanhamentoVistoriaFiltro) => void;
    defaultFilter?: IAcompanhamentoVistoriaFiltro;
    setIdEmpreendimento: Dispatch<SetStateAction<number[]>>;
    idEmpreendimento: number[];
}

const filtroInicial: IAcompanhamentoVistoriaFiltro = {
    ID_PRODUTO_PAI: [] as number[],
    DT_INICIAL: "",
    DT_FINAL: "",
    PAGINA: 1,
    PESQUISA: "",
    ID_USUARIO_RESPONSAVEL: undefined,
    DS_NOME: "",
    NR_CPF: "",
    ID_CASO: 0,
    ID_UNIDADE: [] as number[],
    DS_CLASSIFICACAO: "",
};

export default function FiltroAcompanhamentosVistoria(
    props: IFiltroAcompanhamentosVistoriaProps
) {
    const filter = props.defaultFilter;
    const hadleFilterFormSubmit = props.handleSubmit;

    const FormMethods = useForm();
    const { reset, setValue, register, handleSubmit } = FormMethods;

    const { execute: listarUnidades, value: unidadesListadas } =
    useAsyncCallback(ListarProdutosPorEmpreendimentosController);

    const { execute: listarAtendentes, value: atendentesListados } =
    useAsyncCallback(ListarUsuariosController);

    const idEmpreendimentoRef = useRef<any>();
    const idAtendenteRef = useRef<any>();
    const idUnidadeRef = useRef<any>();
    const idClassificacoesRef = useRef<any>();

    const limparFiltros = () => {
        idEmpreendimentoRef.current?.clearValue();
        idUnidadeRef.current?.clearValue();
        idAtendenteRef.current?.clearValue();
        idClassificacoesRef.current?.clearValue();
        setValue("ID_UNIDADE", []);
        setValue("ID_PRODUTO_PAI", []);
        setValue("ID_CASO", 0);
        setValue("DT_INICIAL", "");
        setValue("DT_FINAL", "");
        setValue("NR_CPF", "");
        setValue("DS_NOME", "");
        setValue("DS_CLASSIFICACAO", "");
    };
    
    
    const [options, setOptions] = useState<
    Array<{ value: number; label: string }> | undefined
    >();
    const [optionsProdutos, setOptionsProdutos] = useState<
    Array<{ value: number; label: string }> | undefined
    >();
    const [optionsAtendentes, setOptionsAtendentes] = useState<
    Array<{ value: number; label: string }> | undefined
    >();

    useEffect(() => {
        listarAtendentes();
    },[])


    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );
    
    useEffect(() => {
        setOptions(() =>
            listarEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_EMPREENDIMENTO,
                value: empreendimento.ID_EMPREENDIMENTO,
            }))
        );
    }, [listarEmpreendimentos]);

    useEffect(() => {
        setOptionsProdutos(() =>
            unidadesListadas?.map((produto) => ({
                label: produto.DS_PRODUTO,
                value: produto.ID_PRODUTO,
            }))
        );
    }, [unidadesListadas]);

    
    useEffect(() => {
        setOptionsAtendentes(() =>
            atendentesListados?.map((atendente) => ({
                label: atendente.DS_NOME,
                value: atendente.ID_USUARIO,
            }))
        );
    }, [atendentesListados]);


    const optionsClassificacoes = [{
        label: "Vistoria - Entrega de Chaves - Conforme ",
        value: "Vistoria - Entrega Chaves",
    },
    {
        label: "Vistoria - Entrega de Chaves - Não Conforme",
        value: "Vistoria - Entrega Chaves Não Conforme",
    },
    {
        label: "Pesquisa de Satisfação - Entrega de Chaves",
        value: "Pesquisa Satisfação - Entrega Chaves",
    },
    {
        label: "Termo de Recebimento - Entrega Chaves",
        value: "Termo de Recebimento",
    }];

    useEffect(() => {
        register("ID_PRODUTO_PAI");
        register("ID_UNIDADE");
        register("ID_CASO");
        register("DT_INICIAL");
        register("DT_FINAL");
        register("NR_CPF");
        register("DS_NOME");
        register("DS_CLASSIFICACAO");
        register("ID_USUARIO_RESPONSAVEL");
    }, [register]);
    

    const onSubmit = (data: IAcompanhamentoVistoriaFiltro) => {
        hadleFilterFormSubmit({
            ...data,
            ID_PRODUTO_PAI: props.idEmpreendimento,
        });
    };

    return (
        <>
            <StickyToolbar active={Boolean(filter)}>
                <FormProvider {...FormMethods}>
                    <UnForm handleSubmit={handleSubmit(onSubmit)} usingContext>
                        <div className="col-12 mt-3">
                            <label>Data Inicio</label>
                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_INICIAL"
                                defaultValue={filter?.DT_INICIAL}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Data Final</label>
                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_FINAL"
                                defaultValue={filter?.DT_FINAL}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Solicitação</label>
                            <UnForm.Input
                                className="form-control"
                                type="number"
                                name="ID_CASO"
                                defaultValue={filter?.ID_CASO}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Nome</label>
                            <UnForm.Input
                                className="form-control"
                                type="text"
                                name="DS_NOME"
                                defaultValue={filter?.DS_NOME}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>CPF/CNPJ</label>
                            <UnForm.Input
                                className="form-control"
                                type="text"
                                maxLength={14}
                                name="NR_CPF"
                                defaultValue={filter?.NR_CPF}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Empreendimento</label>
                            <Select
                                options={options}
                                name="ID_PRODUTO_PAI"
                                ref={idEmpreendimentoRef}
                                isClearable
                                isMulti
                                onChange={(e) => {
                                    const ids = e.map((item) => item?.value) as number[];
                                    props.setIdEmpreendimento(ids);
                                    listarUnidades({
                                        ID_EMPREENDIMENTO: ids,
                                    });
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>
                        <div className={`col-12 mt-3 `}>
                            <label>Unidade</label>
                            <Select
                                options={optionsProdutos}
                                name="ID_UNIDADE"
                                ref={idUnidadeRef}
                                isClearable
                                isMulti
                                onChange={(e) => {
                                    const ids = e.map((item) => item?.value);
                                    setValue("ID_UNIDADE", ids);
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />       
                        </div>
                        <div className={`col-12 mt-3 `}>
                            <label>Classificação</label>
                            <Select
                                options={optionsClassificacoes}
                                name="DS_CLASSIFICACAO"
                                onChange={(e) => setValue("DS_CLASSIFICACAO", e?.value)}
                                ref={idClassificacoesRef}
                                isClearable
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />       
                        </div>

                        <div className="col-12 mt-3">
                            <label>Atendente</label>
                            <Select
                                options={optionsAtendentes}
                                name="ID_USUARIO_RESPONSAVEL"
                                ref={idAtendenteRef}
                                isClearable
                                onChange={(e) => {
                                    const id = e?.value;
                                    setValue("ID_USUARIO_RESPONSAVEL", id);
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />       
                        </div>
                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    window.sessionStorage.removeItem(
                                        "FILTRO_RELATORIO_VISTORIAS_ENTREGA_CHAVES"
                                    );
                                    reset(filtroInicial);
                                    limparFiltros();
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </UnForm>
                </FormProvider>
            </StickyToolbar>
            <ExportExcel
                baixarExcelController={async () =>
                    AcompanhamentoVistoriaExportarExcelController({
                        ...filter,
                        PAGINA: 0,
                    })
                }
                nomeArquivo={`RelatorioAcompanhamentoVistorias`}
            />
        </>
    );
}
